<a href="https://dropdigitalhealth.com" target="_blank">
  @if (!dark()) {
    <img ngSrc="assets/images/logos/Logo_DDH.png" class="block" alt="DDH" height="268" width="512" priority>
  } @else {
    <img ngSrc="assets/images/logos/Logo_DDH_White.png" class="block" alt="DDH" height="268" width="512" priority>
  }
</a>
